import React from 'react';
import Lozenge, { ThemeAppearance } from '@atlaskit/lozenge';
import { ApprovalStatus as ApprovalStatusType } from '@css-xp/apd-common';
import { statusToShow } from './status';

const ApprovalStatus = ({ status }: { status: ApprovalStatusType }) => {
  const visibleStatus = statusToShow[status] ? statusToShow[status].toUpperCase() : status;
  let appearance: ThemeAppearance;
  switch (status) {
    case ApprovalStatusType.APPROVED:
      appearance = 'success';
      break;
    case ApprovalStatusType.DECLINED:
      appearance = 'removed';
      break;
    case ApprovalStatusType.REASONS_REQUESTED:
      appearance = 'inprogress';
      break;
    case ApprovalStatusType.WAITING_FOR_REVIEW:
      appearance = 'new';
      break;
    case ApprovalStatusType.IN_REVIEW:
      appearance = 'moved';
      break;
    case ApprovalStatusType.REASONS_PROVIDED:
      appearance = 'inprogress';
      break;
    case ApprovalStatusType.REQUEST_CANCELED:
      appearance = 'default';
      break;
  }

  return (
    <>
      <Lozenge appearance={appearance}>{visibleStatus}</Lozenge>
    </>
  );
};

export default ApprovalStatus;
